module.exports = __webpack_public_path__ + "img/VR.9af18601.png";